import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import { API_HOST } from '../env.js';

import client from './client';

const adapter = createEntityAdapter({
  sortComparer: (a, b) => { return b.name < a.name ? 1 : -1; }
})

const refreshThunk = createAsyncThunk(
  'trafficImpacts/refresh',
  async () => {
    const response = await client.get(`${API_HOST}/api/traffic-impacts`);
    return response.data;
  },
  {
    condition(arg, thunkApi) {
      return selectStatus(thunkApi.getState()) === 'idle';
    }
  }
);

const selectStatus = (state) => state.trafficImpacts.status;

export const slice = createSlice({
  name: 'trafficImpacts',
  initialState: adapter.getInitialState({
    status: 'idle',
    error: null,
  }),
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(refreshThunk.pending, (state) => {
        state.status = 'pending';
      })
      .addCase(refreshThunk.fulfilled, (state, action) => {
        state.status = 'idle';
        action.payload.sort((a, b) => a.label < b.label ? 1 : -1);
        adapter.setAll(state, action.payload);
      })
      .addCase(refreshThunk.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message ?? 'Unknown Error';
      });
  }
});

export const {
  selectAll: selectAllTrafficImpacts,
  selectById: selectTrafficImpactById,
  selectIds: selectTrafficImpactIds,
} = adapter.getSelectors((state) => state.trafficImpacts);
export {
  refreshThunk as refreshTrafficImpacts,
  selectStatus as selectTrafficImpactStatus,
};

export default slice.reducer;
